<!-- ⚠ Der Hintergrund gehoert mit ins @if: stand er ausserhalb, lief seine
     :enter-Blende schon beim Erzeugen der Seite. Die Blende blendet auf
     opacity .2 auf, danach verwirft Angular die Styles wieder (der Trigger hat
     keinen state) — sichtbar als dunkler Schleier ueber der ganzen Seite. -->
@if (open) {
  <div class="modal__background" @enterLeaveFade (click)="Close()"></div>
  <div class="modal" @enterLeave>
    <ng-content></ng-content>
  </div>
}
